(self["webpackChunkschoolmusicalco"] = self["webpackChunkschoolmusicalco"] || []).push([["/tooltip"],{

/***/ "./src/js/tooltip.js":
/*!***************************!*\
  !*** ./src/js/tooltip.js ***!
  \***************************/
/***/ (() => {

document.addEventListener("DOMContentLoaded", function () {
  var tooltip = document.createElement("div");
  tooltip.className = "tooltip";
  document.body.appendChild(tooltip);
  var overlay = document.createElement("div");
  document.querySelectorAll("[data-tooltip]").forEach(function (elem) {
    elem.addEventListener("click", function (e) {
      e.preventDefault();
      var text = document.getElementById(this.dataset.tooltip);
      tooltip.innerHTML = text.innerHTML;
      var rect = this.getBoundingClientRect();
      tooltip.style.left = rect.left + (window.scrollX - 60) + "px";
      tooltip.style.top = rect.bottom + window.scrollY + "px";
      tooltip.style.display = "block";
      tooltip.classList.add("tooltip-open");
      overlay.className = "tooltip-overlay";
      overlay.style.display = "block";
      document.body.appendChild(overlay);
    });
    overlay.addEventListener("click", function () {
      tooltip.style.display = "none";
      overlay.style.display = "none";
    });
  });
});

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/js/tooltip.js"));
/******/ }
]);